import { Link } from "react-router-dom";
import pathConstant from "../../../../utils/path.constant";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faBullseye, faFileInvoiceDollar } from "@fortawesome/free-solid-svg-icons";

const CstAdminHeader = () => {
    return(
        <div className="ms-auto flex gap-8 px-4 text-gray-600">
            <div>
                <Link to={pathConstant.CST_REVENUE_TARGET} className="uppercase font-semibold px-2 hover:text-orange-400">
                    <FontAwesomeIcon icon={faBullseye} />&nbsp;
                    Target Revenue
                </Link>
            </div>
            {/* <div>
                <Link to={pathConstant.CST_RECRUITERS_PIPELINE} className="uppercase font-semibold px-2 hover:text-orange-400">
                    <FontAwesomeIcon icon={faUsersBetweenLines} />&nbsp;
                    Recruiter's Pipeline
                </Link>
            </div> */}
            <div>
                <Link to={pathConstant.REVENUE_SUMMARY} className="uppercase font-semibold px-2 hover:text-orange-400">
                    <FontAwesomeIcon icon={faFileInvoiceDollar} />&nbsp;
                    Revenue Summary
                </Link>
            </div>
        </div>
    );
}

export default CstAdminHeader;